import {useState, useEffect, Fragment} from 'react'
import MapIcon from "@mui/icons-material/Map";
import ToggleButton from "@mui/material/ToggleButton";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {AppBar, Toolbar,Typography,TextField,Button,Dialog,DialogContent,DialogTitle,CircularProgress} from "@mui/material";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import SearchIcon from "@mui/icons-material/Search";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import AuthModal from './authModal';
import LinearProgress from '@mui/material/LinearProgress';
import SatteliteMapIcon from '@mui/icons-material/Satellite'
import ApiIcon from '@mui/icons-material/Api';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PlaceIcon from '@mui/icons-material/Place';
import ClearIcon from '@mui/icons-material/Clear';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import PeopleIcon from '@mui/icons-material/People';
import SvgIcon from '@mui/material/SvgIcon';
import FindReplaceWidget from './findReplaceWidget'
import { t } from '../utils/strings';
import UserManagementWidget from './userManagementWidget';
import AnalyticsDashboard from './analyticsDashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import BdarLogo from '../assets/BDAR-logo_20.5.2023.png'
import TaycmLogo from '../assets/TAYCM-logo.png'
import CreatorFilter from './creatorFilter';
import ZAProfile from '../assets/ZA_profile.jpg'
import ScholtenProfile from '../assets/Scholten_head.jpg'
import { accent } from '../utils/colorDict';

// Custom icon: spotlight beam from above onto a flat map surface
const MapSpotlightIcon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Flat map in perspective (trapezoid) */}
    <path d="M2 20 L6 13 L18 13 L22 20 Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    {/* Map fold lines */}
    <line x1="9.3" y1="13" x2="8" y2="20" stroke="currentColor" strokeWidth="0.8" opacity="0.5"/>
    <line x1="14.7" y1="13" x2="16" y2="20" stroke="currentColor" strokeWidth="0.8" opacity="0.5"/>
    {/* Spotlight beam (cone from top to map) */}
    <path d="M10.5 3 L7.5 13 L16.5 13 L13.5 3 Z" fill="currentColor" opacity="0.2"/>
    <line x1="10.5" y1="3" x2="7.5" y2="13" stroke="currentColor" strokeWidth="0.8" opacity="0.6"/>
    <line x1="13.5" y1="3" x2="16.5" y2="13" stroke="currentColor" strokeWidth="0.8" opacity="0.6"/>
    {/* Light source at top */}
    <rect x="10" y="1.5" width="4" height="2.5" rx="0.8" fill="currentColor"/>
    {/* Spotlight circle on map */}
    <ellipse cx="12" cy="16.5" rx="3.5" ry="1.8" fill="none" stroke="currentColor" strokeWidth="1.2"/>
  </SvgIcon>
);

const COLLECTION = process.env.REACT_APP_COLLECTION || null;
const isAdmin = (authData: any) => authData?.user?.role === 'admin';
const isEditor = (authData: any) => authData?.user?.role === 'admin' || authData?.user?.role === 'editor';

const aboutTextScholten = `This project attempts to put the photographic collection of Frank Scholten (1881-1942) on the map, based on scans shared with the public by Leiden University Libraries. Participants who contributed to identifying locations and places include Or Aleksandrowicz, Samuel Giller, Shula Widrich, Shay Farkash, Henya Melichson, and Tal Eyal.
MAQOM is a platform designed to provide effective solutions to the challenges of extracting and presenting place-related data from almost all types of digitized and digital media. The first version of the platform was developed as part of the tarboot competition of the National Library of Israel and Yad Hanadiv by a team of researchers at the Technion's BDAR Lab, the Faculty of Architecture and Town Planning. Team: Or Aleksandrowicz, Daniel Rosenberg, Ivan Vasilyev, Elad Horn, Yoav Orion. Current developer: Or Aleksandrowicz.`

const aboutTextAleksandrowicz = `This project maps the photographic collection of Ze'ev Aleksandrowicz (1905-1992), a Polish-born Jewish-Israeli photographer, based on scans by the National Library of Israel. The collection mainly consists of photographs taken between the years of 1932 and 1935 during Aleksandrowicz's visits to British Palestine and to other countries, including Poland, Japan, the United States, and Egypt. The items were indexed by Sinai Aleksandrowicz.
MAQOM is a platform designed to provide effective solutions to the challenges of extracting and presenting place-related data from almost all types of digitized and digital media. The first version of the platform was developed as part of the tarboot competition of the National Library of Israel and Yad Hanadiv by a team of researchers at the Technion's BDAR Lab, the Faculty of Architecture and Town Planning. Team: Or Aleksandrowicz, Daniel Rosenberg, Ivan Vasilyev, Elad Horn, Yoav Orion. Current developer: Or Aleksandrowicz.`

const aboutTextAleksandrowiczHeb = `פרויקט זה מעלה על המפה את אוסף התצלומים של זאב אלכסנדרוביץ' (1992-1905), צלם ישראלי יליד פולין, על בסיס סריקות של הספרייה הלאומית של ישראל. האוסף מורכב בעיקרו מתצלומים שצולמו בין השנים 1932 ל-1935 במהלך ביקוריו של אלכסנדרוביץ' בארץ ישראל המנדטורית ובמדינות נוספות, בהן פולין, יפן, ארצות הברית ומצרים. הפריטים באוסף מופתחו על ידי סיני אלכסנדרוביץ'.
מקום היא פלטפורמה שנועדה לספק פתרונות אפקטיביים לאתגרים הכרוכים בחילוץ והצגה של נתונים מבוססי מיקום מתוך כמעט כל סוגי המדיה הדיגיטלית והדיגיטלית. גרסה ראשונית של הפלטפורמה פותחה במסגרת תחרות tarboot של הספרייה הלאומית ויד הנדיב על ידי צוות חוקרים במעבדה לנתוני עתק במחקר אדריכלי (BDAR) בפקולטה לארכיטקטורה ובינוי ערים בטכניון. צוות הפרויקט: אור אלכסנדרוביץ', דניאל רוזנברג, איוון וסילייב, אלעד הורן, יואב אוריון. מפתח נוכחי: אור אלכסנדרוביץ'.`

const aboutTextScholtenHeb = `פרויקט זה מעלה על המפה את אוסף התצלומים של פרנק סחולטן (1881-1942) שנסרק במלואו בספריות אוניברסיטת ליידן. המשתתפים שתרמו לזיהוי המיקומים והאתרים כוללים את אור אלכסנדרוביץ', שמואל גילר, שולה וידריך, שי פרקש, הניה מליכסון וטל איל.
מקום היא פלטפורמה שנועדה לספק פתרונות אפקטיביים לאתגרים הכרוכים בחילוץ והצגה של נתונים מבוססי מיקום מתוך כמעט כל סוגי המדיה הדיגיטלית והדיגיטלית. גרסה ראשונית של הפלטפורמה פותחה במסגרת תחרות tarboot של הספרייה הלאומית ויד הנדיב על ידי צוות חוקרים במעבדה לנתוני עתק במחקר אדריכלי (BDAR) בפקולטה לארכיטקטורה ובינוי ערים בטכניון. צוות הפרויקט: אור אלכסנדרוביץ', דניאל רוזנברג, איוון וסילייב, אלעד הורן, יואב אוריון. מפתח נוכחי: אור אלכסנדרוביץ'.`


const aboutTextTaycm = `This is an experimental pilot presenting a small selection from the Tel Aviv-Yafo City Museum Archive (TAJA). It maps contemporary photographs of Tel Aviv-Yafo taken in 2006 and between 2023 and 2025, including documentation of damage caused by the missile strikes of June 2025. Images in this pilot are visible to registered users only; titles, descriptions and locations are public. Accounts are created by the site administrators.
MAQOM is a platform designed to provide effective solutions to the challenges of extracting and presenting place-related data from almost all types of digitized and digital media. The first version of the platform was developed as part of the tarboot competition of the National Library of Israel and Yad Hanadiv by a team of researchers at the Technion's BDAR Lab, the Faculty of Architecture and Town Planning. Team: Or Aleksandrowicz, Daniel Rosenberg, Ivan Vasilyev, Elad Horn, Yoav Orion. Current developer: Or Aleksandrowicz.`

const aboutTextTaycmHeb = `זהו פיילוט ניסיוני המציג מבחר קטן מארכיון מוזיאון העיר תל אביב-יפו. האתר ממפה תצלומים עכשוויים של תל אביב-יפו משנת 2006 ומהשנים 2023 עד 2025, ובכללם תיעוד הנזקים שנגרמו במתקפות הטילים של יוני 2025. התמונות בפיילוט זה גלויות למשתמשים רשומים בלבד; הכותרות, התיאורים והמיקומים פתוחים לכול. החשבונות נוצרים על ידי מנהלי האתר.
מקום היא פלטפורמה שנועדה לספק פתרונות אפקטיביים לאתגרים הכרוכים בחילוץ והצגה של נתונים מבוססי מיקום מתוך כמעט כל סוגי המדיה הדיגיטלית. גרסה ראשונית של הפלטפורמה פותחה במסגרת תחרות tarboot של הספרייה הלאומית ויד הנדיב על ידי צוות חוקרים במעבדה לנתוני עתק במחקר אדריכלי (BDAR) בפקולטה לארכיטקטורה ובינוי ערים בטכניון. צוות הפרויקט: אור אלכסנדרוביץ', דניאל רוזנברג, איוון וסילייב, אלעד הורן, יואב אוריון. מפתח נוכחי: אור אלכסנדרוביץ'.`


const aboutTextUnified = `This site brings together multiple geotagged photographic collections on a single map: the Frank Scholten collection (1881-1942), based on scans shared by Leiden University Libraries; the Ze'ev Aleksandrowicz collection (1905-1992), based on scans by the National Library of Israel; the G. Eric and Edith Matson Photograph Collection (1898-1977, ~22,000 photos), held by the Library of Congress; the Pinhas Ben-Shahar Collection (1962-1965, ~550 photos), shared by the Tel Aviv-Yafo Municipal Archive; and a regional subset of the Willem van de Poll Collection (1948-1962, ~7,200 photos covering Israel and neighbouring countries) from the Nationaal Archief of the Netherlands.
MAQOM is a platform designed to provide effective solutions to the challenges of extracting and presenting place-related data from almost all types of digitized and digital media. The first version of the platform was developed as part of the tarboot competition of the National Library of Israel and Yad Hanadiv by a team of researchers at the Technion's BDAR Lab, the Faculty of Architecture and Town Planning. Team: Or Aleksandrowicz, Daniel Rosenberg, Ivan Vasilyev, Elad Horn, Yoav Orion. Current developer: Or Aleksandrowicz. Contributors to the Scholten collection's geotagging include Or Aleksandrowicz, Samuel Giller, Shula Widrich, Shay Farkash, Henya Melichson, and Tal Eyal. The Aleksandrowicz collection was indexed by Sinai Aleksandrowicz.`

const aboutTextUnifiedHeb = `אתר זה מאגד כמה אוספי תצלומים מתויגים גיאוגרפית על מפה אחת: אוסף פרנק סחולטן (1942-1881), על בסיס סריקות של ספריות אוניברסיטת ליידן; אוסף זאב אלכסנדרוביץ׳ (1992-1905), על בסיס סריקות של הספרייה הלאומית של ישראל; אוסף התצלומים של ג'. אריק ואדית מטסון (1977-1898, כ־22,000 תצלומים) מספריית הקונגרס בארה"ב; אוסף פנחס בן־שחר (1965-1962, כ־550 תצלומים), מהארכיון העירוני תל אביב־יפו; ותת־קבוצה אזורית מאוסף וילם ון דה פול (1962-1948, כ־7,200 תצלומים מישראל ומדינות שכנות) מהארכיון הלאומי של הולנד (Nationaal Archief).
מקום היא פלטפורמה שנועדה לספק פתרונות אפקטיביים לאתגרים הכרוכים בחילוץ והצגה של נתונים מבוססי מיקום מתוך כמעט כל סוגי המדיה הדיגיטלית. גרסה ראשונית של הפלטפורמה פותחה במסגרת תחרות tarboot של הספרייה הלאומית ויד הנדיב על ידי צוות חוקרים במעבדה לנתוני עתק במחקר אדריכלי (BDAR) בפקולטה לארכיטקטורה ובינוי ערים בטכניון. צוות הפרויקט: אור אלכסנדרוביץ', דניאל רוזנברג, איוון וסילייב, אלעד הורן, יואב אוריון. מפתח נוכחי: אור אלכסנדרוביץ'. בתיוג הגיאוגרפי של אוסף סחולטן השתתפו אור אלכסנדרוביץ', שמואל גילר, שולה וידריך, שי פרקש, הניה מליכסון וטל איל. הפריטים באוסף אלכסנדרוביץ' מופתחו על ידי סיני אלכסנדרוביץ'.`



// The header is the site's primary colour, so it simply IS the accent — which
// colorDict derives from each collection's own palette. Previously this was a
// ternary chain whose final `else` sent any unrecognised collection to Scholten
// blue, so a new collection silently got the wrong header.
const headerColor = accent;

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

const mapToggleSx = {
  color: 'white',
  borderColor: 'rgba(255,255,255,0.5)',
  '&.Mui-selected': {
    color: 'white',
    backgroundColor: 'rgba(255,255,255,0.25)',
    borderColor: 'rgba(255,255,255,0.8)',
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'rgba(255,255,255,0.35)',
  },
};

const Header=({rightPanel,
              authData,
              handleAuthData,
              rastersWidgetOpen,
              handleRastersWidgetOpen,
              handleRightPanel,
              handleFilterString,
              handleSearch,
              fetchingProgress,
              handleInfoModal,
              setEditMode,
              handleSat,
              mapRef,
              onAddressMarker,
              showQuestionableOnly,
              setShowQuestionableOnly,
              spotlightMode,
              setSpotlightMode,
              hasActiveRaster,
              rastersHidden,
              setRastersHidden,
              resetRasters,
              lang,
              toggleLang,
              creatorOptions,
              selectedCreators,
              setSelectedCreators})=>{
  const [inputString, setInputString] = useState('')
  const [modalOpen,setModalOpen] = useState(false)
  const [satSelected, setSatSelected] = useState(false)
  const [aboutOpen, setAboutOpen] = useState(false)
  const [geotaggedCount, setGeotaggedCount] = useState<number | null>(null)
  const [userMenuAnchor, setUserMenuAnchor] = useState<null | HTMLElement>(null)
  const [searchMode, setSearchMode] = useState<'title' | 'geotagger'>('title')
  const [addressInput, setAddressInput] = useState('')
  const [addressResults, setAddressResults] = useState<any[]>([])
  const [searching, setSearching] = useState(false)
  const [findReplaceOpen, setFindReplaceOpen] = useState(false)
  const [userMgmtOpen, setUserMgmtOpen] = useState(false)
  const [analyticsOpen, setAnalyticsOpen] = useState(false)
  // Phone-vs-desktop layout — used to shrink large header elements (BDAR logo etc.) on small screens.
  const [isPhone, setIsPhone] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 600px)').matches)
  useEffect(() => {
    if (typeof window === 'undefined') return
    const mq = window.matchMedia('(max-width: 600px)')
    const onChange = () => setIsPhone(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])

  const isHebrew = (text: string) => /[\u0590-\u05FF]/.test(text);
  // For RTL detection in inputs: stay RTL (Hebrew UI) unless text contains Latin letters
  const inputIsRtl = (text: string) => lang === 'he' ? !/[a-zA-Z]/.test(text) : isHebrew(text);

  const handleAddressSearch = async (query: string) => {
    if (!query.trim()) { setAddressResults([]); return; }
    try {
      const res = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${MAPBOX_TOKEN}&limit=5&language=he,en`
      );
      const data = await res.json();
      setAddressResults(data.features || []);
    } catch (err) {
      console.error('Geocoding error:', err);
    }
  }

  const handleAddressSelect = (feature: any) => {
    const [lng, lat] = feature.center;
    mapRef?.current?.flyTo({ center: [lng, lat], zoom: 15 });
    setAddressInput(feature.place_name);
    setAddressResults([]);
    onAddressMarker?.({ lng, lat, name: feature.place_name });
  }


  useEffect(() => {
    if (!aboutOpen || geotaggedCount !== null) return;
    // Unified site (no COLLECTION) → omit param so edge function counts across all collections
    const params: any = {};
    if (COLLECTION) params.collection = COLLECTION;
    fetch(`${SUPABASE_URL}/functions/v1/read-api`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${SUPABASE_ANON_KEY}` },
      body: JSON.stringify({ action: 'get_geotagged_count', params }),
    })
      .then(r => r.json())
      .then(d => { if (d.count != null) setGeotaggedCount(d.count); })
      .catch(() => {});
  }, [aboutOpen])

    return <AppBar style={{ backgroundColor: headerColor, height: '80px' }}>
    <AuthModal
    modalOpen={modalOpen}
    handleAuthData={handleAuthData}
    />

    <Dialog open={aboutOpen} onClose={() => { setAboutOpen(false); setGeotaggedCount(null); }} maxWidth="sm">
      <DialogTitle dir={lang === 'he' ? 'rtl' : 'ltr'} style={{ fontFamily: "'Heebo', sans-serif" }}>
        {lang === 'he'
          ? (COLLECTION === 'aleksandrowicz' ? "אוסף זאב אלכסנדרוביץ\u05F3 על המפה" : (COLLECTION === 'scholten' ? "אוסף פרנק סחולטן על המפה" : (COLLECTION === 'taycm' ? "ארכיון מוזיאון העיר תל אביב-יפו — פיילוט" : "היסטוריה מצולמת על המפה")))
          : (COLLECTION === 'aleksandrowicz' ? "Geotagging the Ze'ev Aleksandrowicz Collection" : (COLLECTION === 'scholten' ? "Geotagging the Frank Scholten Collection" : (COLLECTION === 'taycm' ? "Tel Aviv-Yafo City Museum Archive — Pilot" : "Geotagging Visual History")))
        }
      </DialogTitle>
      <DialogContent dir={lang === 'he' ? 'rtl' : 'ltr'}>
        {(lang === 'he' ? (COLLECTION === 'aleksandrowicz' ? aboutTextAleksandrowiczHeb : (COLLECTION === 'scholten' ? aboutTextScholtenHeb : (COLLECTION === 'taycm' ? aboutTextTaycmHeb : aboutTextUnifiedHeb))) : (COLLECTION === 'aleksandrowicz' ? aboutTextAleksandrowicz : (COLLECTION === 'scholten' ? aboutTextScholten : (COLLECTION === 'taycm' ? aboutTextTaycm : aboutTextUnified))))
          .split('\n').map((para, i) => (
          <Typography key={i} paragraph style={{ fontFamily: "'Heebo', sans-serif", textAlign: lang === 'he' ? 'right' : 'left' }}>{para}</Typography>
        ))}
        <Typography paragraph style={{ fontFamily: "'Heebo', sans-serif", textAlign: lang === 'he' ? 'right' : 'left' }}>
          {geotaggedCount !== null
            ? t('currentGeotaggedCount', lang, { count: geotaggedCount.toLocaleString() })
            : t('loadingGeotaggedCount', lang)}
        </Typography>
        <div style={{ borderTop: '1px solid #ddd', marginTop: '8px', paddingTop: '12px' }}>
          <Typography variant="subtitle2" style={{ fontFamily: "'Heebo', sans-serif", fontWeight: 700, marginBottom: '6px', textAlign: lang === 'he' ? 'right' : 'left' }}>
            {t('termsOfUseTitle', lang)}
          </Typography>
          {t('termsOfUseText', lang).split('\n').map((para, i) => {
            const email = t('termsContactEmail', lang);
            const parts = para.split('{email}');
            return (
              <Typography key={i} variant="body2" paragraph style={{ fontFamily: "'Heebo', sans-serif", color: '#555', textAlign: lang === 'he' ? 'right' : 'left' }}>
                {parts.map((part, j) => (
                  <Fragment key={j}>
                    {part}
                    {j < parts.length - 1 && <a href={`mailto:${email}`} dir="ltr" style={{ color: 'inherit' }}>{email}</a>}
                  </Fragment>
                ))}
              </Typography>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>

    <Toolbar
      sx={{
        margin:"auto 0",display:'flex',justifyContent:'space-between',alignItems:'center',padding:'0 1vw'
      }}
      disableGutters
    >
      {/* Language toggle — far left */}
      <div
        onClick={toggleLang}
        title={lang === 'he' ? 'Switch to English' : 'עבור לעברית'}
        style={{
          cursor: 'pointer',
          marginRight: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          lineHeight: 1,
          userSelect: 'none',
          opacity: 0.85,
        }}
      >
        <span style={{
          fontFamily: "'SuezOne-Regular', serif",
          fontSize: '15px',
          color: lang === 'he' ? 'white' : 'rgba(255,255,255,0.45)',
          lineHeight: 1.1,
        }}>עב</span>
        <span style={{
          fontFamily: "'SuezOne-Regular', serif",
          fontSize: '13px',
          color: lang === 'en' ? 'white' : 'rgba(255,255,255,0.45)',
          lineHeight: 1.1,
          letterSpacing: '0.05em',
        }}>EN</span>
      </div>

      {/* Phone-only sign-in / account button + satellite toggle, placed directly
          right of the language toggle. The desktop copies live inside .login_section
          / .login_btn / .admin_btns, which are display:none on phone via CSS. */}
      {isPhone && (
        <>
          {authData?.user?.username ? (
            <IconButton
              onClick={(e) => setUserMenuAnchor(e.currentTarget)}
              style={{ backgroundColor: 'transparent', padding: 4, marginRight: 4 }}
            >
              <Tooltip title={authData.user.username}>
                <AccountCircleIcon sx={{ fontSize: 28, color: 'whitesmoke' }} />
              </Tooltip>
            </IconButton>
          ) : (
            <IconButton
              onClick={() => setModalOpen(!modalOpen)}
              style={{ backgroundColor: 'transparent', padding: 4, marginRight: 4 }}
            >
              <Tooltip title={t('login', lang)}>
                <LoginIcon sx={{ padding: 0.5, background: 'whitesmoke', color: accent, borderRadius: '50%' }} />
              </Tooltip>
            </IconButton>
          )}
          <Tooltip title={t('satellitePhoto', lang)}>
            <ToggleButton
              selected={satSelected}
              onChange={() => {
                setSatSelected(!satSelected);
                handleSat();
              }}
              value="sat-phone"
              size="small"
              sx={mapToggleSx}
            >
              <SatteliteMapIcon />
            </ToggleButton>
          </Tooltip>
          <Tooltip title={showQuestionableOnly ? t('showAllItems', lang) : t('showQuestionableOnly', lang)}>
            <IconButton
              sx={{ cursor: 'pointer', mr: '4px' }}
              onClick={() => setShowQuestionableOnly(prev => !prev)}
            >
              <NotListedLocationIcon sx={{ color: showQuestionableOnly ? '#ff9800' : 'rgba(255,255,255,0.4)' }} />
            </IconButton>
          </Tooltip>
        </>
      )}

      {/* Left section: Login + Search + Admin buttons */}
      <div style={{display:'flex',alignItems:'center',gap:'8px',flex:'1'}}>
        {/* Login/Logout */}
        {authData?.user?.username ?
          <>
          <IconButton
            className="login_section"
            onClick={(e)=>setUserMenuAnchor(e.currentTarget)}
            style={{ backgroundColor: 'transparent' }}
          >
            <Tooltip title={authData.user.username}>
              <AccountCircleIcon sx={{fontSize:32,color:"whitesmoke"}}/>
            </Tooltip>
          </IconButton>
          <Menu
            anchorEl={userMenuAnchor}
            open={Boolean(userMenuAnchor)}
            onClose={()=>setUserMenuAnchor(null)}
            anchorOrigin={{vertical:'bottom',horizontal:'left'}}
            MenuListProps={{ style: { direction: lang === 'he' ? 'rtl' : 'ltr' } }}
          >
            <MenuItem disabled sx={{opacity:'1 !important',fontWeight:'bold'}}>
              {authData.user.username}
            </MenuItem>
            <MenuItem disabled sx={{opacity:'0.7 !important',fontSize:'0.85em',py:0}}>
              {authData.user.role ? authData.user.role.charAt(0).toUpperCase() + authData.user.role.slice(1) : 'Viewer'}
            </MenuItem>
            {isAdmin(authData) &&
              <MenuItem onClick={()=>{
                setUserMenuAnchor(null)
                setUserMgmtOpen(true)
              }}>
                {lang === 'he'
                  ? <>{t('manageUsers', lang)}<ListItemIcon sx={{justifyContent:'flex-end',ml:0,mr:-0.5}}><PeopleIcon fontSize="small"/></ListItemIcon></>
                  : <><ListItemIcon><PeopleIcon fontSize="small"/></ListItemIcon>{t('manageUsers', lang)}</>
                }
              </MenuItem>
            }
            <MenuItem onClick={()=>{
              setUserMenuAnchor(null)
              handleAuthData(null)
              localStorage.removeItem('authdata')
            }}>
              {lang === 'he'
                ? <>{t('logOut', lang)}<ListItemIcon sx={{justifyContent:'flex-end',ml:0,mr:-0.5}}><LogoutIcon fontSize="small"/></ListItemIcon></>
                : <><ListItemIcon><LogoutIcon fontSize="small"/></ListItemIcon>{t('logOut', lang)}</>
              }
            </MenuItem>
          </Menu>
          </>
        :
          <IconButton
            className='login_btn'
            onClick={()=>{
              setModalOpen(!modalOpen)
            }}
            style={{ backgroundColor: 'transparent' }}
          >
            <Tooltip title={t('login', lang)}>
              <LoginIcon sx={{padding:0.5,background:'whitesmoke',color:accent,borderRadius:'50%'}}/>
            </Tooltip>
          </IconButton>
        }

        {/* Search */}
        <form style={{display:'flex',flexDirection:'row',alignItems:'center'}}
          className='search_section'
          onSubmit={async (e)=>{e.preventDefault();
            if (!inputString.length || searching){return}
            setSearching(true)
            try { await handleSearch(inputString, searchMode) } finally { setSearching(false) }
          }}
        >
          <Tooltip title={rightPanel === 5 ? t('closeSearchPanel', lang) : t('openSearchPanel', lang)}>
            <IconButton color="inherit" size="small"
              onClick={()=>{
                if (rightPanel === 5) {
                  handleRightPanel(0)
                } else {
                  handleRightPanel(5)
                }
              }}>
              {rightPanel === 5 ? <SearchOffIcon /> : <SearchIcon />}
            </IconButton>
          </Tooltip>
          <TextField
            autoComplete='off'
            size="small"
            value={inputString}
            inputProps={{
              autoComplete:'off',
              style:{ textAlign: (inputString ? inputIsRtl(inputString) : lang === 'he') ? 'right' : 'left', direction: (inputString ? inputIsRtl(inputString) : lang === 'he') ? 'rtl' : 'ltr' }
            }}
            style={{width:'220px'}}
            sx={{'& .MuiOutlinedInput-notchedOutline':{borderColor:'white'},'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{borderColor:'white'},'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{borderColor:'white'},'& .MuiInputBase-input':{color:'white'},'& .MuiInputBase-input::placeholder':{color:'rgba(255,255,255,0.7)',opacity:1}}}
            onChange={(e) => {setInputString(e.currentTarget.value)}}
            placeholder={searchMode === 'title' ? t('filterByKeyword', lang) : t('searchByGeotagger', lang)}
            InputProps={{
              ...(lang === 'he' ? {
                startAdornment: searching
                  ? <CircularProgress size={18} sx={{ color: 'white' }} />
                  : inputString ? (
                    <IconButton size="small" onClick={() => { setInputString(''); handleFilterString(''); }}
                      sx={{color:'rgba(255,255,255,0.7)',p:'2px'}}>
                      <ClearIcon sx={{fontSize:16}}/>
                    </IconButton>
                  ) : null
              } : {
                endAdornment: searching
                  ? <CircularProgress size={18} sx={{ color: 'white' }} />
                  : inputString ? (
                    <IconButton size="small" onClick={() => { setInputString(''); handleFilterString(''); }}
                      sx={{color:'rgba(255,255,255,0.7)',p:'2px'}}>
                      <ClearIcon sx={{fontSize:16}}/>
                    </IconButton>
                  ) : null
              })
            }}
          />
          <Tooltip title={t('geotaggerSearch', lang)}>
            <IconButton size="small" onClick={() => setSearchMode(m => m === 'title' ? 'geotagger' : 'title')}
              sx={{ color: searchMode === 'geotagger' ? 'white' : 'rgba(255,255,255,0.5)' }}>
              <PersonSearchIcon />
            </IconButton>
          </Tooltip>
          {/* Creator filter (unified site only) — uses the shared CreatorFilter
              so the dropdown looks and sorts identically here and in the search/
              homeless widgets. */}
          {!COLLECTION && (
            <CreatorFilter
              creatorOptions={creatorOptions || []}
              selected={Array.isArray(selectedCreators) ? selectedCreators : []}
              onChange={setSelectedCreators}
              lang={lang}
              iconSize={30}
              iconColor="rgba(255,255,255,0.7)"
            />
          )}
          <Tooltip title={showQuestionableOnly ? t('showAllItems', lang) : t('showQuestionableOnly', lang)}>
            <IconButton
              sx={{ cursor: "pointer" }}
              onClick={() => setShowQuestionableOnly(prev => !prev)}
            >
              <NotListedLocationIcon
                sx={{ color: showQuestionableOnly ? '#ff9800' : 'rgba(255,255,255,0.4)' }}
              />
            </IconButton>
          </Tooltip>
        </form>

        {/* Admin buttons */}
        <div style={{display:'flex',alignItems:'center'}} className='admin_btns'>
          {isEditor(authData) ?
            <IconButton
              sx={{ cursor: "pointer" }}
              onClick={() => {if (rightPanel!==1){
                handleRightPanel(1)
                }
              else{handleRightPanel(0)}}}
            >
              <Tooltip title={t('geotagPhotos', lang)}>
                <TouchAppIcon
                    sx={{color:rightPanel===1 || rightPanel===3 ? "white" : 'rgba(255,255,255,0.7)' }}
                />
              </Tooltip>
            </IconButton>
            : null
          }

          {/* Edit photo location button — hidden, functionality moved to item modal
          {authData?.user?.username ?
            <IconButton
              sx={{ cursor: "pointer" }}
              onClick={() => {if (rightPanel!==2){
                handleRightPanel(2)
                setEditMode(true)
                }
              else{
                handleRightPanel(0)
                setEditMode(false)
              }}}
            >
              <Tooltip title="Edit photo location">
                <EditLocationIcon
                    sx={{color:rightPanel===2 || rightPanel===3 ? "white" : 'primary' }}
                />
              </Tooltip>
            </IconButton>
            : null
          }
          */}

          {isAdmin(authData) && COLLECTION === 'scholten' ?
          <IconButton
            sx={{ cursor: "pointer"}}
            onClick={() => {if (rightPanel!==6){
              handleRightPanel(6)
              }
            else{handleRightPanel(0)}}}
          >
            <Tooltip title={t('externalApi', lang)}>
              <ApiIcon
                  sx={{color:rightPanel===6 ? "white" : 'primary' }}
              />
            </Tooltip>
          </IconButton>
          : null
          }



          {isAdmin(authData) &&
            <Tooltip title={t('findReplace', lang)}>
              <IconButton sx={{ cursor: "pointer" }} onClick={() => setFindReplaceOpen(true)}>
                <FindReplaceIcon sx={{ color: 'rgba(255,255,255,0.5)' }} />
              </IconButton>
            </Tooltip>
          }
          {isAdmin(authData) &&
            <Tooltip title={lang === 'he' ? 'נתוני שימוש' : 'Engagement analytics'}>
              <IconButton sx={{ cursor: "pointer" }} onClick={() => setAnalyticsOpen(true)}>
                <BarChartIcon sx={{ color: 'rgba(255,255,255,0.5)' }} />
              </IconButton>
            </Tooltip>
          }
          <FindReplaceWidget open={findReplaceOpen} onClose={() => setFindReplaceOpen(false)} lang={lang} />
          <UserManagementWidget open={userMgmtOpen} onClose={() => setUserMgmtOpen(false)} authData={authData} />
          <AnalyticsDashboard open={analyticsOpen} onClose={() => setAnalyticsOpen(false)} />

          {/* Address search */}
          <div style={{position:'relative',marginLeft:'16px',marginRight:'16px'}}>
            <div style={{display:'flex',alignItems:'center'}}>
              <PlaceIcon sx={{color:'rgba(255,255,255,0.7)',fontSize:20,mr:'2px'}}/>
              <TextField
                autoComplete='off'
                size="small"
                value={addressInput}
                onChange={(e) => {
                  setAddressInput(e.target.value);
                  handleAddressSearch(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && addressResults.length > 0) {
                    e.preventDefault();
                    handleAddressSelect(addressResults[0]);
                  }
                }}
                placeholder={t('goToAddress', lang)}
                inputProps={{autoComplete:'off',style:{textAlign: (addressInput ? inputIsRtl(addressInput) : lang === 'he') ? 'right' : 'left', direction: (addressInput ? inputIsRtl(addressInput) : lang === 'he') ? 'rtl' : 'ltr', padding:'4px 8px'}}}
                style={{width:'220px'}}
                sx={{'& .MuiOutlinedInput-notchedOutline':{borderColor:'rgba(255,255,255,0.5)'},'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{borderColor:'white'},'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{borderColor:'white'},'& .MuiInputBase-input':{color:'white',fontSize:'13px'},'& .MuiInputBase-input::placeholder':{color:'rgba(255,255,255,0.6)',opacity:1}}}
                InputProps={{
                  ...(lang === 'he' ? {
                    startAdornment: addressInput ? (
                      <IconButton size="small" onClick={() => { setAddressInput(''); setAddressResults([]); onAddressMarker?.(null); }}
                        sx={{color:'rgba(255,255,255,0.7)',p:'2px'}}>
                        <ClearIcon sx={{fontSize:16}}/>
                      </IconButton>
                    ) : null
                  } : {
                    endAdornment: addressInput ? (
                      <IconButton size="small" onClick={() => { setAddressInput(''); setAddressResults([]); onAddressMarker?.(null); }}
                        sx={{color:'rgba(255,255,255,0.7)',p:'2px'}}>
                        <ClearIcon sx={{fontSize:16}}/>
                      </IconButton>
                    ) : null
                  })
                }}
              />
            </div>
            {addressResults.length > 0 && (
              <div style={{position:'absolute',top:'100%',left:0,right:0,backgroundColor:'white',borderRadius:'4px',boxShadow:'0 4px 12px rgba(0,0,0,0.3)',zIndex:9999,maxHeight:'240px',overflow:'auto',marginTop:'4px'}}>
                {addressResults.map((feature) => (
                  <div key={feature.id}
                    onClick={() => handleAddressSelect(feature)}
                    style={{padding:'8px 12px',cursor:'pointer',fontSize:'13px',color:'#333',borderBottom:'1px solid #eee',textAlign: lang === 'he' ? 'right' : 'left',direction: lang === 'he' ? 'rtl' : 'ltr'}}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                  >
                    {feature.place_name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Map toggles */}
          <ToggleButton
            selected={(hasActiveRaster && !rastersHidden) || rastersWidgetOpen}
            onClick={(e) => {
              if (e.detail === 1) {
                (window as any).__rasterClickTimer = setTimeout(() => {
                  if (!hasActiveRaster) {
                    // No rasters configured: just toggle panel
                    handleRastersWidgetOpen();
                  } else if (rastersHidden && !rastersWidgetOpen) {
                    // State 0 → 1: open panel + restore rasters
                    setRastersHidden(false);
                    handleRastersWidgetOpen();
                  } else if (!rastersHidden && rastersWidgetOpen) {
                    // State 1 → 2: close panel, rasters stay on
                    handleRastersWidgetOpen();
                  } else if (!rastersHidden && !rastersWidgetOpen) {
                    // State 2 → 0: hide rasters
                    setRastersHidden(true);
                  }
                }, 250);
              } else if (e.detail === 2) {
                clearTimeout((window as any).__rasterClickTimer);
                if (hasActiveRaster) {
                  if (!rastersHidden) {
                    // State 1 → 0: hide rasters + close panel
                    setRastersHidden(true);
                    if (rastersWidgetOpen) handleRastersWidgetOpen();
                  } else {
                    // State 0 → 2: restore rasters, panel stays closed
                    setRastersHidden(false);
                  }
                }
              }
            }}
            value="rasters"
            size="small"
            sx={mapToggleSx}
          >
            <Tooltip title={t('historicalMaps', lang)}>
              <MapIcon />
            </Tooltip>
          </ToggleButton>

          <Tooltip title={spotlightMode ? t('exitSpotlightMode', lang) : t('spotlightMode', lang)}>
            <ToggleButton
              selected={spotlightMode}
              onChange={() => setSpotlightMode(!spotlightMode)}
              value="spotlight"
              size="small"
              style={{marginLeft:'4px'}}
              sx={mapToggleSx}
            >
              <MapSpotlightIcon />
            </ToggleButton>
          </Tooltip>

          <Tooltip title={t('satellitePhoto', lang)}>
            <ToggleButton
              selected={satSelected}
              onChange={() => {
                setSatSelected(!satSelected);
                handleSat();
              }}
              value="sat"
              size="small"
              style={{marginLeft:'4px'}}
              sx={mapToggleSx}
            >
              <SatteliteMapIcon />
            </ToggleButton>
          </Tooltip>

        </div>
      </div>

      {/* Right section: Lab logo + (per-collection) title + MAQOM */}
      <div style={{display:'flex',alignItems:'center',gap:'16px'}}>
        {/* Project title with profile image — per-collection sites only.
            On the unified site, the title block is omitted and the MAQOM logo opens About. */}
        {COLLECTION && (
          <div style={{display:'flex',alignItems:'center',gap:'16px',cursor:'pointer'}} onClick={()=>setAboutOpen(true)}>
            {COLLECTION === 'aleksandrowicz' ? <a href="https://www.zeevaleksandrowicz.com/" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
              <img src={ZAProfile} alt="Ze'ev Aleksandrowicz"
              style={{height:'55px',borderRadius:'50%',filter:'invert(1) brightness(2)',mixBlendMode:'screen',marginTop:'-8px'}} />
            </a> : COLLECTION === 'taycm' ? null : <img src={ScholtenProfile} alt="Frank Scholten"
              style={{height:'55px',borderRadius:'50%',filter:'invert(1) brightness(1.4) contrast(0.7)',mixBlendMode:'screen',marginTop:'-8px'}} />}
            <Typography
              fontSize="0.88em"
              color="white"
              sx={{lineHeight:1.3,textAlign:'center','&:hover':{textDecoration:'underline'}, fontFamily: "'Heebo', sans-serif", fontWeight: 300}}
            >
              {lang === 'he'
                ? (COLLECTION === 'aleksandrowicz'
                    ? <span dir="rtl">{"אוסף זאב אלכסנדרוביץ׳"}<br/>{"על המפה"}</span>
                    : COLLECTION === 'taycm' ? <span dir="rtl">{"ארכיון מוזיאון העיר"}<br/>{"תל אביב-יפו"}</span> : <>אוסף פרנק סחולטן<br/>על המפה</>)
                : (COLLECTION === 'aleksandrowicz'
                    ? <>Geotagging the Ze'ev<br/>Aleksandrowicz Collection</>
                    : COLLECTION === 'taycm' ? <>Tel Aviv-Yafo<br/>City Museum Archive</> : <>Geotagging the<br/>Frank Scholten Collection</>)
              }
            </Typography>
          </div>
        )}

        {/* Lab logo */}
        <a href="https://oraleks.net.technion.ac.il/en/bdar-lab/" target="_blank" rel="noopener noreferrer">
          <img src={BdarLogo} alt="BDAR Lab" style={{height:isPhone?'22px':'35px',filter:'brightness(0) invert(1)'}} />
        </a>

        {/* Partner logo — the collection's holding institution. Same white
            treatment as the BDAR logo, since the source artwork is dark navy
            and would otherwise disappear against the header. */}
        {COLLECTION === 'taycm' && (
          <img src={TaycmLogo} alt="Tel Aviv-Yafo City Museum"
            style={{height:isPhone?'22px':'35px',filter:'brightness(0) invert(1)'}} />
        )}

        {/* MAQOM logo stacked: Hebrew top, English middle, Arabic bottom.
            On the unified site this is the About trigger. */}
        <Tooltip title={!COLLECTION ? t('aboutTooltip', lang) : ''} disableHoverListener={!!COLLECTION}>
          <div
            style={{display:'flex',flexDirection:'column',alignItems:'center',lineHeight:1, cursor: !COLLECTION ? 'pointer' : 'default'}}
            className='logo_header'
            onClick={!COLLECTION ? () => setAboutOpen(true) : undefined}
          >
            <Typography fontSize={isPhone ? '1.6875em' : '1.35em'} color="white" className='header_heb' sx={{lineHeight:1}}>
              מָקוֹם
            </Typography>
            <Typography fontSize={isPhone ? '1.5em' : '1.2em'} color="white" className='header_lat' sx={{lineHeight:1}}>
              MAQOM
            </Typography>
            <Typography fontSize={isPhone ? '1.875em' : '1.5em'} color="white" className='header_ar' sx={{lineHeight:1}}>
              مَقُوم
            </Typography>
          </div>
        </Tooltip>
      </div>
    </Toolbar>

    {/* Pin the loading bar to the bottom edge of the AppBar so its
        appearance/disappearance doesn't reflow the toolbar contents. */}
    {fetchingProgress && (
      <LinearProgress sx={{ position: 'absolute', left: 0, right: 0, bottom: 0, zIndex: 2 }} />
    )}

  </AppBar>
}

export default Header
